import { routes } from '../config/routes';
import { SAVE_TAX_SUB_CAT } from './ExplorePage';

export const FundTypes = [
  {
    key: 'All_Mutual_Funds',
    title: 'Top Funds & NFOs',
    icon: 'AllMutualFundsIcon',
    route: routes.EXPLORE.url,
  },
  {
    key: 'Save_Tax',
    title: 'Save Tax',
    icon: 'SaveTaxIcon',
    route: routes.EXPLORE.url + `/EQ?subCategory=${SAVE_TAX_SUB_CAT}`,
  },
  // {
  //   key: 'Plan_Goals_With_SIP',
  //   title: 'Plan your goals with SIP',
  //   icon: 'StartASipIcon',
  //   route: routes.PLAN_SIP.url,
  // },
  {
    key: 'Plan_Goals_With_SIP',
    title: 'Insta SIP',
    icon: 'StartASipIcon',
    route: routes.PLAN_SIP.url,
  },
  {
    key: 'Investment_Ideas',
    title: 'Explore Investment Ideas',
    icon: 'InvestmentIdeasIcon',
    route: routes.INVESTMENT_IDEAS.url,
  },
];
